<template>
  <div class="sidebar-container has-logo">
    <sidebar-logo />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        :unique-opened="true"
        mode="vertical"
        router
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { constantRoutes } from '@/router'
import { filterRoutesByPermission, parsePermissions, filterSuperOnlyRoutes } from '@/utils/permission'
import SidebarLogo from './Logo'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarLogo, SidebarItem },
  computed: {
    ...mapGetters(['isStationAdmin', 'permissions']),
    routes() {
      let list = constantRoutes.filter(r => {
        if (r.hidden || !r.children) return false
        return true
      })
      list = filterSuperOnlyRoutes(list, this.isStationAdmin)
      const parsed = parsePermissions(this.permissions)
      // 总站管理员未配置权限时，兼容旧数据：显示全部菜单
      if (!parsed.length && !this.isStationAdmin) {
        return list
      }
      return filterRoutesByPermission(list, this.permissions)
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) return meta.activeMenu
      return path
    }
  }
}
</script>

<style scoped>
.scrollbar-wrapper {
  overflow-x: hidden !important;
}

.el-scrollbar {
  height: calc(100vh - 50px);
  background-color: #304156;
}

.el-scrollbar__view {
  background-color: #304156;
}

::v-deep .el-scrollbar__bar.is-horizontal {
  display: none;
}
</style>
